import { eventEmitter } from './emitter';
import { eventSubscriber } from './subscriber';
import { EventMiddleware } from './middleware';
import { list, types } from './types';

const setupEventMiddleware = () => EventMiddleware;

export { eventSubscriber, eventEmitter, list, types, setupEventMiddleware };
